import { createAsyncThunk } from '@reduxjs/toolkit';

import axios from '../axios';

export const fetchOrder = createAsyncThunk(
  'orders/fetchOrder',
  async (orderId) => {
    const http = axios({ version: 'v5.2' });

    const response = await http.get(`/carts/${orderId}`);

    return response.data;
  },
);
